import React from 'react';
import PropTypes from 'prop-types';

import {Box, Chip, Stack, Typography} from 'views/components';
import {Person} from 'views/icons';
import {Translate} from 'views/module';

const ReviewSection = (props) => {
  const {reviews, questions} = props;

  const formattedReviews = React.useMemo(() => reviews.map((review) => {
    let text = review.text.trim();
    text = text.replace(/^"+|"+$/g, '');
    text = text ? `"${text}"` : '';
    return {
      ...review,
      text,
    };
  }), [reviews]);

  const reviewChips = questions.reviewChips;
  const showReviewChips = reviewChips && reviewChips.length > 0;

  if (!reviews.length) {
    return null;
  }

  return (
    <Stack alignItems="flex-start" width="100%" spacing={{xs: 2, md: 3}} sx={{}}>
      {
        showReviewChips &&
        <Stack spacing={1.5}>
          <Typography
            variant="body1"
            fontWeight="bold"
            sx={{
              color: '#686868',
              letterSpacing: '0.04em',
              textTransform: 'uppercase',
            }}
          >
            <Translate expression='caregiverDetail.Review.FrequentlyMentionedSubtitle'/>
          </Typography>
          <Stack
            direction="row"
            justifyContent="flex-start"
            gap={1}
            rowGap={1}
            flexWrap="wrap"
          >
            {
              reviewChips.map((chipLabel, idx) => (
                <Chip
                  key={idx}
                  label={chipLabel}
                  sx={{
                    bgcolor: 'white',
                    borderRadius: 4,
                    border: 1,
                    borderColor: 'color.divider',
                    color: 'black',
                    fontSize: '0.75rem',
                    fontWeight: 500,
                    py: 1,
                    px: 2,
                  }}
                />
              ))
            }
          </Stack>
        </Stack>
      }

      <Stack spacing={1.5}>
        <Typography
          variant="body1"
          fontWeight="bold"
          sx={{
            color: '#686868',
            letterSpacing: '0.04em',
            textTransform: 'uppercase',
          }}
        >
          <Translate expression='caregiverDetail.Review.HaveToSaySubtitle'/>
        </Typography>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: {xs: '1fr', sm: '1fr 1fr', md: '1fr 1fr 1fr'},
            gap: 2,
            width: '100%',
          }}
        >
          {
            formattedReviews.map((r) => {
              return (
                <Stack
                  key={r.caregiverReviewRn}
                  spacing={2}
                  sx={{
                    'p': 2,
                    'borderRadius': 2,
                    'bgcolor': 'color.white',
                    'width': '100%',
                    'boxSizing': 'border-box',
                    'border': '1px solid',
                    'borderColor': 'color.divider',
                    'm': 0,
                  }}
                >
                  <Stack direction="row" alignItems="center" spacing={1}>
                    <Person sx={{color: '#DA7955', fontSize: 20}} />
                    <Typography variant="subtitle2" fontWeight="bold" color="text.primary">
                      {r.reviewerName}
                      <Typography component="span" variant="caption" sx={{color: '#686868', ml: 0.5}}>
                        {`— ${r.relationship}`}
                      </Typography>
                    </Typography>

                  </Stack>
                  <Typography variant="body2" sx={{color: '#686868', lineHeight: '24px'}}>
                    {r.text}
                  </Typography>
                </Stack>
              );
            })
          }
        </Box>
      </Stack>
    </Stack>
  );
};

ReviewSection.propTypes = {
  questions: PropTypes.shape({
    firstName: PropTypes.string.isRequired,
    reviewChips: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  reviews: PropTypes.arrayOf(
      PropTypes.shape({
        caregiverReviewRn: PropTypes.string.isRequired,
        reviewerName: PropTypes.string.isRequired,
        relationship: PropTypes.string.isRequired,
        date: PropTypes.string.isRequired,
        text: PropTypes.string.isRequired,
        isVerified: PropTypes.bool.isRequired,
        rating: PropTypes.number.isRequired,
      }),
  ).isRequired,
};

export default React.memo(ReviewSection);
